class UsersModelModel {

  private _id: any;

  private _user_name: any;

  private _user_email: any;

  private _mobile_number: any;

  private _qualification: any;


  constructor(data: any) {

    this._id = data["id"];

    this._user_name = data["user_name"];

    this._user_email = data["user_email"];

    this._mobile_number = data["mobile_number"];

    this._qualification = data["qualification"];

  }


  public getId(): any {
    return this._id;
  }

  public setId(value: any) {
    this._id = value;
  }


  public getUser_name(): any {
    return this._user_name;
  }

  public setUser_name(value: any) {
    this._user_name = value;
  }


  public getUser_email(): any {
    return this._user_email;
  }

  public setUser_email(value: any) {
    this._user_email = value;
  }


  public getMobile_number(): any {
    return this._mobile_number;
  }

  public setMobile_number(value: any) {
    this._mobile_number = value;
  }


  public getQualification(): any {
    return this._qualification;
  }

  public setQualification(value: any) {
    this._qualification = value;
  }



  public toJson(): any {
    return {

      "id": this._id,

      "user_name": this._user_name,

      "user_email": this._user_email,

      "mobile_number": this._mobile_number,

      "qualification": this._qualification,

    };
  }

  public static fromJson(json: any): UsersModelModel {
    return new UsersModelModel(json);
  }
}

export default UsersModelModel;
